(() => {
  if (window.nwCommerceActionsReady || !window.IntersectionObserver) return;
  window.nwCommerceActionsReady = true;
  const selector = 'button[data-nw-commerce-action], a[href][data-nw-commerce-action]';
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new Set();
  const seen = new Set();
  const visible = new WeakMap();

  function consider(button) {
    const blocked = !['add', 'checkout'].includes(button.dataset.nwCommerceAction)
      || button.matches(':disabled, [aria-disabled="true"], [aria-busy="true"], .loading')
      || button.closest('[hidden], [aria-hidden="true"], [inert]');
    if (blocked || motion.matches) {
      if (button.classList.contains('nw-commerce-cue')) button.classList.remove('nw-commerce-cue');
      return;
    }
    const key = button.dataset.nwCommerceKey || button.id;
    if (!key || seen.has(key) || !visible.get(button) || !button.isConnected
      || getComputedStyle(button).visibility !== 'visible') return;
    // Keep this in page memory: no tracking/consent state, and section refreshes
    // cannot restart an attention loop for the same shopping action.
    seen.add(key);
    button.classList.add('nw-commerce-cue');
    window.setTimeout(() => button.classList.remove('nw-commerce-cue'), 900);
  }

  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      visible.set(entry.target, entry.isIntersecting && entry.intersectionRatio >= 0.85);
      consider(entry.target);
    }
  }, {threshold: 0.85});

  function visit(node, callback) {
    if (node.nodeType !== 1) return;
    if (node.matches(selector)) callback(node);
    node.querySelectorAll(selector).forEach(callback);
  }
  function register(button) {
    if (observed.has(button)) return;
    observed.add(button);
    observer.observe(button);
  }
  function unregister(button) {
    observer.unobserve(button);
    observed.delete(button);
    visible.delete(button);
    button.classList.remove('nw-commerce-cue');
  }

  visit(document.documentElement, register);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'childList') {
        record.removedNodes.forEach(node => visit(node, unregister));
        record.addedNodes.forEach(node => visit(node, register));
      } else visit(record.target, button => { register(button); consider(button); });
    }
  }).observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'hidden', 'aria-hidden', 'inert', 'class', 'data-nw-commerce-action'],
  });
  motion.addEventListener('change', () => observed.forEach(consider));
})();
